import React from "react";
import Button from "helpers/button";
import RichText from "components/rich-text";
import { getHorizontalAlign } from "helpers/get-section-align";
import getTitleColor from "helpers/get-title-color";

const CtaInfo = ({ data }) => {
  const {
    horizontalAlign: { horizontalAlign },
    backgroundImage,
    title,
    description,
    buttons,
    titleColor
  } = data;

  const components = {
    normal: ({ children }) => (
      <p className="font-montserrat text-lg sm:text-base max-w-xl text-center text-white sm:inline">{children}</p>
    ),
  };

  return (
    <div
      className={`py-12 flex relative bg-white ${getHorizontalAlign(horizontalAlign)}`}
    >
      {backgroundImage && (
        <div className="absolute top-0 left-0 w-full h-full">
          <img src={backgroundImage?.src} className="w-full h-full" />
        </div>
      )}
      <div className="container relative z-[4] flex flex-col items-center">
        <h2 className={`header ${getTitleColor(titleColor)} !text-yellow-400 !text-[62px]`}>{title}</h2>
        <div className="my-6">
          <RichText value={description.data} components={components} />
        </div>
        {buttons && (
          <div className="inline-flex items-center gap-4">
            {buttons.map((button, index) => (
              <Button button={button} key={index} className="!px-10" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CtaInfo;
